// FiltersPanel — Presentational panel of cuisine/price/rating/distance filters.
// Composes FilterSelect and pulls the option tables from the logic layer.
//
// Extracted VERBATIM from `components/RestaurantSearch.js` (behavior-preserving
// refactor, issue #240). Render-only, wrapped in React.memo. Markup, styles,
// text, and the exact onChange parsing (parseFloat for minRating, parseInt for
// radius) are identical to the source.
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';
import { cuisineOptions, priceOptions, ratingOptions, radiusOptions } from '../logic/filterOptions';
import { FilterSelect } from './FilterSelect';

export const FiltersPanel = React.memo(function FiltersPanel({ filters, hasActiveFilters, onFilterChange, onClearFilters }) {
  return (
    <div style={{
      padding: '16px',
      border: '1px solid #e5e7eb',
      borderRadius: '6px',
      backgroundColor: '#f9fafb',
      marginBottom: '16px'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '12px'
      }}>
        <h4 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Filters</h4>
        {hasActiveFilters && (
          <button
            onClick={onClearFilters}
            style={{
              padding: '4px 8px', fontSize: '12px', color: '#d32f2f',
              border: 'none', backgroundColor: 'transparent', cursor: 'pointer'
            }}
          >
            Clear all
          </button>
        )}
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '12px'
      }}>
        <FilterSelect
          label="Cuisine"
          value={filters.cuisine}
          onChange={(e) => onFilterChange('cuisine', e.target.value)}
          options={cuisineOptions}
        />
        <FilterSelect
          label="Price Range"
          value={filters.priceRange}
          onChange={(e) => onFilterChange('priceRange', e.target.value)}
          options={priceOptions}
        />
        <FilterSelect
          label="Minimum Rating"
          value={filters.minRating}
          onChange={(e) => onFilterChange('minRating', parseFloat(e.target.value))}
          options={ratingOptions}
        />
        <FilterSelect
          label="Distance (miles)"
          value={filters.radius}
          onChange={(e) => onFilterChange('radius', parseInt(e.target.value))}
          options={radiusOptions}
        />
      </div>
    </div>
  );
});

export default FiltersPanel;
